var isNode = require('detect-node')

exports = module.exports = isNode ? require('./spankpay-node') : require('./spankpay-browser')
